/*
  "+N Renk" etiketinde taslak kardes urunleri eleme — UAT canli bulgu 18 (2026-09-24).

  custom.siblings JSON'u ailenin TUM urunlerini tutar ve urun durumu (taslak /
  etkin) icermez. PDP her kardesi all_products ile cozdugu icin taslaklar
  kendiliginden elenir; kartlar ise ham girdi sayisini kullaniyordu
  (Alfi Kugel: 5 girdi, 3'u taslak -> PLP "+4 Renk", PDP 2 renk).
  Liquid'de sayfa basina 20 all_products aramasi siniri oldugu icin kontrol
  burada, Storefront API ile yapilir: taslak / yayinda olmayan urun `null` doner.

  - Istekler toplanir, tek sorguda (en fazla 50 handle) gonderilir; sonuc
    sayfa boyunca bellekte tutulur.
  - Liquid kartlari: `[data-sib-groups]` etiketi kontrol bitene kadar gizli
    (visibility: hidden) basilir; sonra dogru metinle gosterilir ya da silinir.
    Istek basarisiz olursa Liquid'in bastigi eski metin gosterilir.
  - Alpine yuzeyleri (arama sayfasi, arama paneli): JumboSib.countFor() senkron
    doner; sonuc henuz yoksa null verir ve Alpine.store('jumboSib').v artinca
    bilesen yeniden hesaplar.
*/
(function () {
  if (window.JumboSib) return;

  var API = '/api/2025-07/graphql.json';
  var TOKEN = '6b1ed1876ff825f0be825f417998caf6';
  var BATCH = 50;

  var active = {};   // handle -> true (yayinda) | false (taslak/yok)
  var pending = {};  // handle -> true (kuyrukta ya da istekte)
  var failed = false;
  var queue = [];
  var timer = null;

  function bump() {
    try {
      if (window.Alpine && Alpine.store('jumboSib')) Alpine.store('jumboSib').v++;
    } catch (e) {}
    scanCards();
  }

  function request(handles) {
    var vars = {};
    var defs = [];
    var fields = [];
    handles.forEach(function (h, i) {
      vars['h' + i] = h;
      defs.push('$h' + i + ': String!');
      fields.push('p' + i + ': product(handle: $h' + i + ') { id }');
    });
    return fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': TOKEN },
      body: JSON.stringify({ query: 'query(' + defs.join(', ') + ') {' + fields.join(' ') + '}', variables: vars })
    })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (j) {
        if (!j || !j.data) throw new Error('bos yanit');
        handles.forEach(function (h, i) {
          active[h] = !!j.data['p' + i];
          delete pending[h];
        });
      });
  }

  function flush() {
    timer = null;
    var list = queue.splice(0);
    var batches = [];
    for (var i = 0; i < list.length; i += BATCH) batches.push(list.slice(i, i + BATCH));
    Promise.all(batches.map(request))
      .catch(function () {
        failed = true;
        list.forEach(function (h) { delete pending[h]; });
      })
      .then(bump);
  }

  function want(handles) {
    handles.forEach(function (h) {
      if (!h || h in active || pending[h]) return;
      pending[h] = true;
      queue.push(h);
    });
    if (queue.length && !timer) timer = setTimeout(flush, 30);
  }

  function parseSiblings(raw) {
    if (!raw) return [];
    if (typeof raw === 'string') {
      try { raw = JSON.parse(raw); } catch (e) { return []; }
    }
    return Array.isArray(raw) ? raw : [];
  }

  // Her renk girdisinin handle'lari: OptionType 1/2 ust seviye Handle,
  // OptionType 3 (renk + boyut) Sizes[].Handle.
  function groupsFromSiblings(arr) {
    return arr.map(function (e) {
      if (!e) return [];
      var h = e.Handle || e.handle;
      if (h) return [h];
      return (e.Sizes || []).map(function (s) { return s && (s.Handle || s.handle); }).filter(Boolean);
    });
  }

  // groups: [[handle,...], ...]; self: mevcut urunun handle'i.
  // Doner: kendisi haric yayindaki renk sayisi | null (henuz bilinmiyor).
  function countGroups(groups, self, extra) {
    var all = [];
    groups.forEach(function (g) { all = all.concat(g); });
    (extra || []).forEach(function (h) { all.push(h); });
    all = all.filter(function (h) { return h && h !== self; });
    want(all);
    if (failed) return null;
    for (var i = 0; i < all.length; i++) if (!(all[i] in active)) return null;

    var n = 0;
    groups.forEach(function (g) {
      if (g.indexOf(self) !== -1) return;
      if (g.some(function (h) { return active[h]; })) n++;
    });
    (extra || []).forEach(function (h) { if (h && h !== self && active[h]) n++; });
    return n;
  }

  function handleOf(product) {
    var n = (product && product.node) || product || {};
    if (n.handle) return n.handle;
    if (product && product.handle) return product.handle;
    var url = (product && product.url) || n.url || '';
    var m = String(url).match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  // --- Liquid kartlari (snippets/main-product-card.liquid) ---
  function labelText(count, secondary) {
    if (count > 0 && secondary > 0) return '+ ' + (count + secondary) + ' Seçenek';
    if (count > 0) return '+ ' + count + ' Renk';
    if (secondary > 0) return '+ ' + secondary + ' Seçenek';
    return '';
  }

  function scanCards(root) {
    var els = (root || document).querySelectorAll('[data-sib-groups]:not([data-sib-done])');
    Array.prototype.forEach.call(els, function (el) {
      var groups = String(el.getAttribute('data-sib-groups') || '').split('|').filter(Boolean)
        .map(function (g) { return g.split(',').filter(Boolean); });
      var manual = String(el.getAttribute('data-sib-manual') || '').split(',').filter(Boolean);
      var self = el.getAttribute('data-sib-self') || '';
      var secondary = parseInt(el.getAttribute('data-sib-secondary'), 10) || 0;
      var row = el.closest('.mpc__options-row') || el;

      var count = countGroups(groups, self, manual);
      if (count === null) {
        if (failed) { el.setAttribute('data-sib-done', ''); row.classList.remove('is-sib-pending'); }
        return;
      }
      el.setAttribute('data-sib-done', '');
      var text = labelText(count, secondary);
      if (text) {
        el.textContent = text;
        row.classList.remove('is-sib-pending');
      } else {
        row.remove();
      }
    });
  }

  window.JumboSib = {
    // Alpine yuzeyleri: siblings (ham metafield degeri) + urun -> sayi | null
    countFor: function (rawSiblings, product) {
      return countGroups(groupsFromSiblings(parseSiblings(rawSiblings)), handleOf(product), []);
    },
    failed: function () { return failed; },
    scan: scanCards
  };

  document.addEventListener('alpine:init', function () {
    if (!Alpine.store('jumboSib')) Alpine.store('jumboSib', { v: 0 });
  });

  function start() {
    scanCards();
    // Sonsuz kaydirma, AJAX filtre, son gezilenler gibi sonradan eklenen kartlar
    var raf = 0;
    var mo = new MutationObserver(function (list) {
      if (raf) return;
      for (var i = 0; i < list.length; i++) {
        if (list[i].addedNodes && list[i].addedNodes.length) {
          raf = requestAnimationFrame(function () { raf = 0; scanCards(); });
          return;
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
